module.exports = function (products) {
    const productsMapper = [];
    products.map((product) => {
        productsMapper.push(`${product.Stockcode}|${product.Quantity}|${product.ListPrice}|${product.SalePrice}`);
    });
    return {
        event: 'trolleyproductarray',
        eventContext: {
            productarray: productsMapper
        }
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/analytics/trolly-product-update.js
 **/